import React from "react";
import { logger } from "../../utils";
import { MediaProps, withMediaStreamTrack } from "./withMediaStreamTrack";

class AudioPlayback extends React.Component<MediaProps> {
  private audio?: HTMLAudioElement;

  constructor(props: MediaProps) {
    super(props);
  }

  componentDidMount() {
    logger.debug("AudioPlayback: Mounting component");
    if (this.audio) {
      logger.debug("AudioPlayback: Setting stream", this.props.stream);
      this.audio.srcObject = this.props.stream;
    }
  }

  render() {
    logger.debug("Rendering AudioPlayback component");
    return <audio autoPlay ref={this.setElementRef} />;
  }

  setElementRef = (element: HTMLAudioElement) => {
    this.audio = element;
  };
}

export const AudioPlaybackWithTrack = withMediaStreamTrack(AudioPlayback);
